<template>
  <div class="select-users-kist">
    <draggable-dynamic-table ref="selectUsersList"
                             :data="data"
                             :columns="columnsLabel"
                             :options="options"
                             :in-modal="true"
                             @column:select="selectedRows = $event, checkStatus($event)"
                             @filter:set="setFilters($event)"
                             @sort:set="setSort($event)"
                             @load:more="getUsers()"/>


    <vs-button id="selectUsers" class="useral-action-button" @click="$emit('selected', selectedRows)"/>
  </div>
</template>

<script>
import {getUsers} from '@/http/requests/users'
import axios from 'axios'

export default {
  name: 'selectUsers',
  data () {
    return {
      checkStatusTimer: 0,
      selectedRows: [],
      insertPromptStatus: false,
      loadingTimer: 0,
      selectedCashBoxes: [],
      options: {
        rowKeyField: 'id'
      },
      columnsLabel: [
        {
          field: 'total_times',
          i18n: 'users.list.table.header.totalTime',
          width: '150px',
          minWidth: 150,
          align: 'center',
          /*filter: true,
          filterType: 'checkbox',
          filterTypes: []*/
          sortable: true,
          filter: true,
          filterTypes: [
            {
              icon: 'EQUAL',
              name: 'برابر باشد',
              id: 1
            },
            {
              icon: 'NOT_EQUAL',
              name: 'برابر نباشد',
              id: 2
            },
            {
              icon: 'GTE',
              name: 'بزرگتر مساوی',
              id: 3
            },
            {
              icon: 'LTE',
              name: 'کوچکتر مساوی',
              id: 4
            }
          ]
        },
        {
          field: 'email',
          i18n: 'users.list.table.header.email',
          width: 'calc((100% / 4))',
          minWidth: 150,
          align: 'center',
          filter: true,
          filterType: 'search',
          filterTypes: [
            {
              icon: 'SEARCH',
              name: 'شامل شود',
              id: 1
            }
          ],
          sortable: true
        },
        {
          field: 'name',
          i18n: 'users.list.table.header.name',
          width: 'calc((100% / 4) * 2)',
          minWidth: 150,
          align: 'center',
          filter: true,
          filterType: 'search',
          filterTypes: [
            {
              icon: 'SEARCH',
              name: 'شامل شود',
              id: 1
            }
          ],
          sortable: true
        },
        {
          field: 'id',
          i18n: 'users.list.table.header.row',
          width: '70px',
          minWidth: 70,
          align: 'center',
          autoIncrement: true,
          fixed: true,
          footer: {
            textType: 'price'
          }
        },
        {
          field: 'select',
          i18n: 'users.select.table.header.select',
          width: '50px',
          minWidth: 50,
          align: 'center',
          selectable: true,
          multiSelect: this.multiSelect,
          locked: true
        }
      ],
      data: [],
      page: 1,
      filters: {},
      sorts: ['order[0]=created_at,desc'],
      endedList: false
    }
  },
  props: {
    multiSelect: {
      type: Boolean,
      default: () => { return true }
    },
    openingBalance: {
      type: String,
      default: ''
    },
    customer: {
      type: Boolean,
      default: () => { return false }
    },
    supplier: {
      type: Boolean,
      default: () => { return false }
    },
    defaultFilter: {
      type: Object,
      default: () => { return {} }
    }
  },
  created () {

    if (this.defaultFilter.length > 0) {
      this.defaultFilter.forEach(item => {
        this.filters.push(item)
      })
    }

    if (this.openingBalance) {
      this.filters.openingInventory = `${this.openingBalance}`
    }

    if (this.customer) {
      this.filters.customer = 'true'
    }

    if (this.supplier) {
      this.filters.supplier = 'true'
    }

    this.getUsers()
  },
  methods: {
    checkStatus (selected) {
      if (!this.multiSelect) {
        clearTimeout(this.checkStatusTimer)
        this.checkStatusTimer = setTimeout(() => {
          selected.forEach((select) => {
            if (select.show) this.$emit('selected', this.selectedRows)
          })
        }, 500)
      }
    },
    getUsers () {
      if (!this.endedList) {
        if (this.$refs.usersListTable && this.data.length === 0) {
          this.$refs.usersListTable.loadMoreStatus = 'FirstLoad'
        } else if (this.$refs.usersListTable && this.data.length > 0) {
          this.$refs.usersListTable.loadMoreStatus = 'Loading'
        }

        getUsers(this.page, this.filters, this.sorts).then((res) => {
          res.data.data.forEach((user) => {

            this.data.push({
              id: user.id,
              name: `${user.name || ''} ${user.family || ''}`,
              email: {
                value: user.email ? user.email : '',
                route: user.email ? `mailto:${user.email}` : null,
                routeType: 'external'
              },
              total_times: user.total_times ? user.total_times : 0
            })
          })

          this.page = res.data.pagination.current_page + 1
          this.endedList = res.data.pagination.current_page === res.data.pagination.total_pages
          const setting = res.data.extra.settings
          if (res.data.pagination.current_page === 1) {
            const row_index = this.columnsLabel.map((e) => {
              return e.field
            }).indexOf('row')
            this.columnsLabel[row_index].footer.value = res.data.pagination.total
          }

          /*const address_index = this.columnsLabel.map((e) => {
            return e.field
          }).indexOf('address')
          if (address_index > -1) {
            if (this.columnsLabel[address_index].filterTypes.length === 0) {
              if (res.data.extra.filters.provinces) {
                this.setProvinceFilterOptions(res.data.extra.filters.provinces)
              }
            }
          }*/
          const balance_index = this.columnsLabel.map((e) => {
            return e.field
          }).indexOf('balance')
          if (balance_index > -1) {
            this.columnsLabel[balance_index].footer.value = this.$u.priceFormat(res.data.extra.total.balance * -1, true)
          }
          const debt_index = this.columnsLabel.map((e) => {
            return e.field
          }).indexOf('maxDebt')
          if (debt_index > -1) {
            this.columnsLabel[debt_index].permission = `${setting.max_debt_active ? 'user.show' : 'false'}`
          }

          const roles_index = this.columnsLabel.map((e) => {
            return e.field
          }).indexOf('accessGroup')
          if (roles_index > -1) {
            if (this.columnsLabel[roles_index].filterTypes.length === 0) {
              if (this.filterTableOptions.roles) {
                this.setRoleFilterOptions(this.filterTableOptions.roles)
              }
            }
          }

          if (this.$refs.usersListTable) this.$refs.usersListTable.loadMoreStatus = ''
        })
          .catch((error) => {
            if (this.$refs.usersListTable && !axios.isCancel(error)) this.$refs.usersListTable.loadMoreStatus = 'Danger'
          })
      }
    },
    setProvinceFilterOptions (provinces) {
      const address_index = this.columnsLabel.map((e) => {
        return e.field
      }).indexOf('address')
      if (address_index > -1) {
        this.columnsLabel[address_index].filterTypes = this.selectedFilters && this.selectedFilters.province ? this.selectedFilters.province.search : []
        const existProvincesId = this.columnsLabel[address_index].filterTypes.map(elm => elm.id)
        provinces.forEach(province => {
          if (existProvincesId.indexOf(province.id) === -1) {
            this.columnsLabel[address_index].filterTypes.push({
              id: province.id,
              label: this.$t(`countries.${province.country.slug}.provinces.${province.slug}`),
              value: province.id,
              show: false
            })
          }
        })
      }
    },
    setRoleFilterOptions (roles) {
      const roles_index = this.columnsLabel.map((e) => {
        return e.field
      }).indexOf('accessGroup')
      if (roles_index > -1) {
        if (roles.length === 0) {
          this.columnsLabel[roles_index].permission = false
        }
        this.columnsLabel[roles_index].filterTypes = this.selectedFilters && this.selectedFilters.roles ? this.selectedFilters.roles.search : []
        const existRolesId = this.columnsLabel[roles_index].filterTypes.map(elm => elm.id)
        this.columnsLabel[roles_index].filterTypes = [
          {
            id: 'no-role',
            label: this.$t('users.labels.notHave'),
            value: 'no-role',
            show: false
          }
        ]
        roles.forEach(role => {
          if (existRolesId.indexOf(role.id) === -1) {
            this.columnsLabel[roles_index].filterTypes.push({
              id: role.id,
              label: role.name,
              value: role.id,
              show: false
            })
          }
        })
      }
    },
    setFilters (filters) {
      const filters_list = {}
      Object.keys(filters).forEach((key) => {
        switch (key) {

        case 'accessGroup':
          if (filters[key].search.length) {
            const role_id = filters[key].search.map(elm => {
              return elm.show ? elm.id : null
            }).filter(elm => {
              return elm !== null
            }).join(this.$u.globalData.filterSeperator)

            if (role_id !== '') filters_list.role = `${  role_id}`
          }
          break

        case 'balance':
          if (filters[key].search !== '') filters_list.balance = `${  this.$u.parseFloat(filters[key].search) * -1  },${  filters[key].type.id}`
          break

        case 'email':
          if (filters[key].search !== '') filters_list.email = `${  filters[key].search  }`
          break

        case 'address':
          if (filters[key].search.length) {
            const province_id = filters[key].search.map(elm => {
              return elm.show ? elm.id : null
            }).filter(elm => {
              return elm !== null
            }).join(this.$u.globalData.filterSeperator)

            if (province_id !== '') filters_list.province = `${  province_id}`
          }
          break

        case 'phone_number':
          if (filters[key].search !== '') filters_list.phone_number = `${filters[key].search}`
          break

        case 'company':
          if (filters[key].search !== '') filters_list.company = `${filters[key].search}`
          break

        case 'name':
          if (filters[key].search !== '') filters_list.full_name = `${filters[key].search}`
          break

        case 'registryDate':
          if (filters[key].search !== '') {
            let filter = ''
            if (Array.isArray(filters[key].search)) {
              filter = filters[key].search.map(elm => this.$u.convertLocaleToUtc(elm, this.$u.locale.validator('moment.date'))).join(this.$u.globalData.filterSeperator)
            } else {
              filter = this.$u.convertLocaleToUtc(filters[key].search, this.$u.locale.validator('moment.date'))
            }
            filters_list.created_at = `${filter}`
          }
          break
        }
      })

      if (Object.values(this.defaultFilter).length > 0) {
        Object.keys(this.defaultFilter).forEach(key => {
          if (this.defaultFilter[key]) {
            filters_list[key] = this.defaultFilter[key]
          }
        })
      }

      if (this.openingBalance) {
        this.filters.openingInventory = `${this.openingBalance}`
      }

      if (this.customer) {
        filters_list.customer = 'true'
      }

      if (this.supplier) {
        filters_list.supplier = 'true'
      }

      this.data = []
      this.page = 1
      this.endedList = false
      this.filters = filters_list
      this.$nextTick(() => {
        this.getUsers()
      })
    },
    setSort (columns) {
      const sorts_list = []
      Object.keys(columns).forEach((key) => {
        switch (key) {

        case 'row':
          sorts_list.push(`order[0]=id,${columns[key] ? 'desc' : 'asc'}`)
          break

          /*case "accessGroup":
            sorts_list.push("order[0]=role," + (columns[key] ? 'desc' : 'asc'))
            break;*/

        case 'email':
          sorts_list.push(`order[0]=email,${  columns[key] ? 'desc' : 'asc'}`)
          break

        case 'balance':
          sorts_list.push(`order[0]=virtual_balance,${columns[key] ? 'desc' : 'asc'}`)
          break

        case 'phone_number':
          sorts_list.push(`order[0]=phone_number,${columns[key] ? 'desc' : 'asc'}`)
          break

        case 'company':
          sorts_list.push(`order[0]=company,${columns[key] ? 'desc' : 'asc'}`)
          break

        case 'name':
          sorts_list.push(`order[0]=name,${columns[key] ? 'desc' : 'asc'}`)
          break

        case 'registryDate':
          sorts_list.push(`order[0]=created_at,${columns[key] ? 'desc' : 'asc'}`)
          break

        case 'group':
          sorts_list.push(`order[0]=group,${columns[key] ? 'desc' : 'asc'}`)
          break

        case 'gender':
          sorts_list.push(`order[0]=gender,${columns[key] ? 'desc' : 'asc'}`)
          break
        }
      })

      if (sorts_list.length === 0) sorts_list.push('order[0]=created_at,desc')

      this.data = []
      this.page = 1
      this.endedList = false
      this.sorts = sorts_list
      this.$nextTick(() => {
        this.getUsers()
      })
    }
  }
}
</script>

<style scoped>
.select-users-kist {
  height: 100%;
}
</style>
